import { lazy } from 'react';

const PlanPersonalBoard = lazy(() => import('./PlanPersonalBoard'));
const PlanDeptBoard = lazy(() => import('./PlanDeptBoard'));
const PlanCompanyBoard = lazy(() => import('./PlanCompanyBoard'));
const PlanMajorIssue = lazy(() => import('./PlanMajorIssue'));
const PlanDeptReport = lazy(() => import('./PlanDeptReport'));
const PlanCompanyReport = lazy(() => import('./PlanCompanyReport'));

export const planPageRoutes = [
  { path: '/plan/personal', component: PlanPersonalBoard },
  { path: '/plan/dept', component: PlanDeptBoard },
  { path: '/plan/company', component: PlanCompanyBoard },
  { path: '/plan/major-issue', component: PlanMajorIssue },
  { path: '/plan/report/dept', component: PlanDeptReport },
  { path: '/plan/report/company', component: PlanCompanyReport }
];
